import Avatar from './src/avatar.mjs';
export { avatarEmits, avatarProps } from './src/avatar2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAvatar = withInstall(Avatar);

export { ElAvatar, ElAvatar as default };
//# sourceMappingURL=index.mjs.map
